module.exports = __webpack_public_path__ + "static/media/glanum_wohnhaus.a8966de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_wohnhaus.png
// module id = 727
// module chunks = 0